import { render, staticRenderFns } from "./CancelledConnections.vue?vue&type=template&id=3ab53ce2&scoped=true"
import script from "./CancelledConnections.vue?vue&type=script&lang=ts"
export * from "./CancelledConnections.vue?vue&type=script&lang=ts"
import style0 from "./CancelledConnections.vue?vue&type=style&index=0&id=3ab53ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab53ce2",
  null
  
)

export default component.exports